// extracted by mini-css-extract-plugin
export const root = "exhibition-info-module--root--1ndbr";
export const logos = "exhibition-info-module--logos--3-ULH";
export const dark = "exhibition-info-module--dark--43ieR";